module.exports = new __parcel__URL__("space_elixir_icon_large.90cadcf5.png").toString();